import React, { useState } from 'react';
import { FiFile } from 'react-icons/fi';

export default function Inventoryupload() {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [submittedFiles, setSubmittedFiles] = useState([]);

  const handleFileSelect = (event) => {
    const files = Array.from(event.target.files);
    const newFiles = files.map((file) => ({
      name: file.name,
      size: `${(file.size / 1024).toFixed(2)} KB`,
      uploadedAt: new Date().toLocaleString(),
    }));
    setSelectedFiles((prev) => [...prev, ...newFiles]);
  };


  return (
    <div className="min-h-screen p-6 bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-white">
      {/* Heading */}
      <div className="mb-4">
        <h1 className="text-3xl font-bold text-gray-800 dark:text-white">All Inventory</h1>
        <hr className="border-gray-400 mt-2" />
      </div>

      {/* Upload Box */}
     

      {/* Uploaded Files Table */}
      <div className="w-full bg-white dark:bg-gray-500 rounded-xl shadow p-6 border border-gray-300 dark:border-gray-700">
        <h2 className="text-2xl font-semibold mb-4">Files</h2>

        {submittedFiles.length === 0 ? (
          <p className="text-gray-500 dark:text-gray-400">No files Found</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full text-md text-left">
              <thead className="bg-blue-400 dark:bg-gray-700 text-gray-700 dark:text-gray-200">
                <tr>
                  <th className="px-4 py-2">#</th>
                  <th className="px-4 py-2">File Name</th>
                  <th className="px-4 py-2">Size</th>
                  <th className="px-4 py-2">Uploaded At</th>
                  <th className="px-4 py-2">Actions</th>
                </tr>
              </thead>
              <tbody className="text-gray-800 dark:text-gray-100">
                {submittedFiles.map((file, index) => (
                  <tr key={index} className="border-b dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700">
                    <td className="px-4 py-2">{index + 1}</td>
                    <td className="px-4 py-2">{file.name}</td>
                    <td className="px-4 py-2">{file.size}</td>
                    <td className="px-4 py-2">{file.uploadedAt}</td>
                    <td className="px-4 py-2">
                      <button
                        onClick={() =>
                          setSubmittedFiles((prev) => prev.filter((_, i) => i !== index))
                        }
                        className="text-red-500 hover:text-red-700 text-sm font-medium"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
